import { docodeHexResponse } from '../../../_common/common.utils';
import AccountMappingTypes from './account-mapping.types';

const INITIAL_STATE = {
	// FETCH ACCOUNT MAP DETAILS
	getAccountMappingResponse: null,
	getAccountMappingArr: [],
	// UPDATE ACCOUNT MAP DETAILS
	updateAccountMappingResponse: null,
	updateAccountMappingArr: [],
};

const accountMappingReducer = (state = INITIAL_STATE, action: any) => {
	switch (action.type) {
		/** ***************** GET ACCOUNT MAPPING START *********************** */
		case AccountMappingTypes.ACCOUNT_MAP_DETAILS_SUCCESS:
			return {
				...state,
				getAccountMappingResponse: action.payload,
				getAccountMappingArr: docodeHexResponse(action.payload, 'GetAccountMapDetailsKey'),
			};
		case AccountMappingTypes.ACCOUNT_MAP_DETAILS_FAILURE:
			return { ...state, getAccountMappingResponse: action.payload };

		case AccountMappingTypes.ACCOUNT_MAP_DETAILS_RESPONSE_CHANGED:
			return { ...state, getAccountMappingResponse: null };
		/** ***************** GET GST TYPE LIST END *********************** */

		/** ***************** UPDATE ACCOUNT MAPPING START *********************** */
		case AccountMappingTypes.UPDATE_ACCOUNT_MAP_DETAILS_SUCCESS:
			return {
				...state,
				updateAccountMappingResponse: action.payload,
				updateAccountMappingArr: docodeHexResponse(
					action.payload,
					'UpdateAccountMapDetailsKey',
				),
			};
		case AccountMappingTypes.UPDATE_ACCOUNT_MAP_DETAILS_FAILURE:
			return { ...state, updateAccountMappingResponse: action.payload };

		case AccountMappingTypes.UPDATE_ACCOUNT_MAP_DETAILS_RESPONSE_CHANGED:
			return { ...state, updateAccountMappingResponse: null };
		/** ***************** UPDATE ACCOUNT MAPPING DETAILS END *********************** */

		default:
			return state;
	}
};
export default accountMappingReducer;
